// extracted by mini-css-extract-plugin
module.exports = {"btn-download":"ExportReport_btn-download__2K9eD"};